import { inject, Injectable, signal } from '@angular/core';
import { take } from 'rxjs';
import { RestApiV2Service } from '../http/rest-api-v2.service';
import { UserService } from '../user-management/user.service';
import { SelfTakerSurvey } from '../../../shared/models/self-takers/self-taker-survey.model';

@Injectable({
  providedIn: 'root',
})
export class SelfTakerSurveyService {
  private readonly apiService = inject(RestApiV2Service);
  private readonly userService = inject(UserService);
  readonly surveys = signal<SelfTakerSurvey[]>([]);

  loadSelfTakerSurveys(): void {
    this.apiService
      .get<{ data: { surveys: SelfTakerSurvey[] } }>(
        `self-taker-surveys/${this.userService.userData()?.user_info?.id}`,
      )
      .request$
      .pipe(take(1))
      .subscribe((response) => {
        this.surveys.set(response.data.surveys ?? []);
      });
  }

  addSurvey(survey: SelfTakerSurvey): void {
    this.surveys.update((current) => {
      if (current.some((row) => row.id === survey.id)) {
        return current;
      }
      return [survey, ...current];
    });
  }
}
